<template>
  <div class="captcha-mask" v-if="show">
    <div class="mask"></div>
    <div class="captcha-box">
    <div class="iconfont icon-close" @click="closeModal"></div>
    <div class="captcha-content">
      <p>为了您的账号安全，请输入验证码</p>
      <input class="input" v-model="myCaptcha" type="text" placeholder="请输入下方图形验证码">
      <div class="captcha-img">
        <div class="captcha-img-content">
          <img class="img" :src="imageCaptcha.data"/>
        </div>
        <span @click="getImageCaptcha">看不清楚，换一张</span>
      </div>
      <button @click="sendCaptcha">确定</button>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: () => false
    },
    name: {
      type: String,
      default: () => 'tool.sms-sender'
    },
    phone: {
      type: String,
      default: () => ''
    },
    operation: {
      type: String,
      default: () => 'login'
    },
  },

  data() {
    return {
      show: false,
      imageCaptcha: {},
      myCaptcha: '',
    }
  },

  watch: {
    showModal(val) {
      this.show = val;
      if (this.show) {
        this.getImageCaptcha();
      }
    }
  },

  mounted() {
    this.getImageCaptcha();
  },

  methods: {
    getImageCaptcha() {
      this.$http.get({name: 'captcha-generator'}).then(res => {
        this.imageCaptcha = res.data;
      })
    },

    sendCaptcha() {
      if (!this.myCaptcha) {
        this.toast('请输入图片验证码！');
        return;
      }
      this.$emit('hideModal');

      this.$http.get({
        name: this.name,
        data: {
          phone: this.phone,
          product: '来学网',
          operation: this.operation,
          captcha_id: this.imageCaptcha.captchaId,
          captcha_value: this.myCaptcha
        },
      }).then(res => {
        if (res.data.error_code != 'SUCCESS') {
          this.toast(res.data.message);
          return;
        }
        this.$emit('handleMessage')
      })
      this.myCaptcha = '';
      this.imageCaptcha = {};
    },

    closeModal() {
      this.$emit('hideModal');
    }
  }
}
</script>
<style scoped>
.captcha-mask {
  width: 100%;
  height: 100%;
}
.mask { 
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background:rgba(0,0,0,0.3);
}

.captcha-box {
  position: fixed;
  top: 308px;
  left: 50%;
  margin-left: -304px;
  width: 608px;
  height: 480px;
  z-index: 9999;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 816px 0px rgba(255, 255, 255, 0.63);
}

.captcha-box .icon-close {
  position: fixed;
  box-sizing: border-box;
  top: 320px;
  left: 50%;
  margin-left: 234px;
  padding: 12px;
  width: 48px;
  height: 48px;
  font-size: 32px;
  font-weight: bold;
  color: #999;
}

.captcha-content {
  margin: 70px auto 0 auto;
  width: 510px;
}

.captcha-content p {
  font-size: 30px;
  line-height: 30px;
  color: #333;
  font-weight: 600;
}

.captcha-content .input {
  display: inline-block;
  margin-top: 44px;
  padding-left: 26px;
  height: 80px;
  color: #999;
  font-weight: 500;
  font-size: 28px;
  line-height: 28px;
  border: 2px solid #CCC;
  border-radius: 10px;
}

.captcha-content input::-webkit-input-placeholder{
  color:#999;
}
.captcha-content input::-moz-placeholder{   /* Mozilla Firefox 19+ */
  color:#999;
}
.captcha-content input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  color:#999;
}
.captcha-content input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
  color:#999;
}

.captcha-content .captcha-img {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 28px;
  height: 80px;
  overflow: hidden;
}

.captcha-img span {
  margin-left: 20px;
  font-size: 24px;
  color: #db2828;
  font-weight: 400;
  line-height: 80px;
}

.captcha-img-content {
  width: 260px;
  height: 80px;
  background: #eee;
}

.captcha-img-content .img {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.captcha-content button {
  margin-top: 36px;
  height: 64px;
  width: 100%;
  color: #fff;
  font-size: 30px;
  border: none;
  font-weight: 500;
  background: #3f98ea;
  text-align: center;
  outline: none;
}
</style>